module.exports = __webpack_public_path__ + "static/media/order.4b0d5681.svg";